module.exports = __webpack_public_path__ + "static/15-the-shift-towards-employee-owned-hr-75738871acfd970108177edefecb84da.jpg";